import api from '../api';
import { dashboardApi } from '../apiVariables';
import { knowledgeBaseApi } from '../apiVariables';


const handleApiCall = (apiConfig: any) => {
  return new Promise((resolve, reject) => {
    api(apiConfig).then(resolve).catch(reject);
  });
};

export const getDashboardCsvFile = () => {
  const { csvFile: csvFileConfig } = dashboardApi;
    const apiConfig = {...csvFileConfig};
    return handleApiCall(apiConfig);

};
